import { getInternalDataEntities } from '../../utils/commonDataEntities.utils';

import { decoratePipe } from '../reducers/decoratePipe';
import { setInternalPipes } from '../reducers/internalPipes.reducer';
import { PipesAPI } from '../../api/pipes.api';

import type { AppThunk } from '../../types/state.types';
import type { PipeResponse } from '../../types/pipes.types';
import type { ApiConf } from '../../types/common.types';

export const InternalPipesThunks = {
  loadInternalPipes: (apiConf: ApiConf): AppThunk => {
    return (dispatch) => {
      return PipesAPI.getAll(apiConf, true).then((allPipes) => {
        const filtered = getInternalDataEntities<PipeResponse>(allPipes).map((p: PipeResponse) =>
          decoratePipe(p)
        );
        dispatch(setInternalPipes(filtered));
      });
    };
  },
};
